import { Component } from '@theme/component';

/**
 * THIRD Space: フッターの営業日カレンダー。モバイル幅(560px以下、CSS側で
 * 判定)では今月・来月の2か月を両方表示せず1か月だけ表示し、このボタンで
 * 表示する月を切り替える。PC幅ではCSSのメディアクエリでボタン自体を隠し、
 * 常に両方表示する(JS側はクラスを付け外しするだけで、表示/非表示の
 * 実際の判定はCSSに任せている)。
 *
 * @typedef {object} Refs
 * @property {HTMLElement} months
 * @property {HTMLButtonElement} navButton
 * @property {HTMLElement} navSpacer
 *
 * @extends {Component<Refs>}
 */
class FooterCalendarNav extends Component {
  requiredRefs = ['months', 'navButton'];

  /** @type {boolean} */
  #showingNext = false;

  connectedCallback() {
    super.connectedCallback();
    this.refs.navButton.addEventListener('click', () => this.#toggle());
  }

  #toggle() {
    this.#showingNext = !this.#showingNext;
    this.refs.months.classList.toggle('ts-footer-calendar__months--show-next', this.#showingNext);
    this.refs.navButton.classList.toggle('ts-footer-calendar__nav-btn--prev', this.#showingNext);
    this.refs.navSpacer?.classList.toggle('ts-footer-calendar__nav-spacer--next', this.#showingNext);
    this.refs.navButton.textContent = this.#showingNext ? '◀' : '▶';
    this.refs.navButton.setAttribute('aria-label', this.#showingNext ? '今月を表示' : '次月を表示');
  }
}

if (!customElements.get('footer-calendar')) {
  customElements.define('footer-calendar', FooterCalendarNav);
}
